<script>
    import Card from '@/components/Card'

    export default {
        components: {
            Card,
        },

        mounted() {
            this.$root.dataLanguages;
            this.$root.restrictCountries('*')
            this.$store.commit('mainPage', {
                current: this.$t('References'),
                stack: [{
                    'path': '/references',
                    'title': this.$t('References'),
                }]
            })
        }
    }
</script>

<template>
    <section class="section">
        <div class="container-fluid">
            <card class="is-card-table has-pagination has-bottom-left-hidden">
                <bg-table-references :label="$t('References')"/>
            </card>
        </div>
    </section>
</template>
